<template>
    <div class="form-group row smart-input-marker" v-if="visible">
      <b-input-group class="col-md-8" style="margin-top: -20px;">
        <span ref="dummyInput" class="form-control dummy-input-box">
          {{ styleData.shipment }}
        </span>
      </b-input-group>
    </div>
</template>
  
<script>
import { applySmartInputStyles, clearSmartInputStyles } from "../../../common/inputStyleHelper";

export default {
    name: "DummyInputBox",
    props: {
        shipment: String,
        isDummyInput: Boolean,
        styleData: Object,
        duration: {
            type: Number,
            default: 10000 //10s
        },
    },
    data() {
        return { visible: false };
    },
    watch: {
        isDummyInput(val) {
            if (val) {
                if(this.styleData && this.styleData != null){
                    this.visible = true;
                    this.applyStyles(this.styleData, this.duration, false);
                }

                // auto-hide after duration
                setTimeout(() => {
                    this.visible = false;
                }, this.duration);
            }
        }
    },
    methods: {
        applyStyles(styleData, delay, isPaddingRequired = false) {
            this.$nextTick(() => {
                if (this.$refs.dummyInput) {
                    applySmartInputStyles(this.$refs.dummyInput, styleData, isPaddingRequired, true, delay);
                }
            });
        },
        clearStyles() {
            if (this.$refs.dummyInput) {
                this.visible = false;
                clearSmartInputStyles(this.$refs.dummyInput);
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/components/common/smartInput.vue?5b816e09